import ArtistScreenReducer from "./slice.applicationForm";
import authReducer from "./slice.auth";
import profileReducer from "./reducer.profile";
import competitionReducer from "./reducer.competition";
import institutionReducer from "./reducer.institutions";
import jobReducer from "./reducer.jobs";
import scriptReducer from "./reducer.scripts";
import subscriptionReducer from "./reducer.subscription";

const rootReducer = {
  authReducer,
  ArtistScreenReducer,
  profileReducer,
  competitionReducer,
  institutionReducer,
  jobReducer,
  scriptReducer,
  subscriptionReducer,
};

export default rootReducer;